"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdkCalculateAmountReceivedParamsSchema = exports.SdkUpdateSlippageParamsSchema = exports.SdkEstimateRelayerFeeParamsSchema = exports.SdkUpdateSlippageSchema = exports.SdkBumpTransferParamsSchema = exports.SdkXCallParamsSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const nxtp_utils_1 = require("@connext/nxtp-utils");
exports.SdkXCallParamsSchema = typebox_1.Type.Object({
    origin: nxtp_utils_1.TIntegerString,
    destination: nxtp_utils_1.TIntegerString,
    to: nxtp_utils_1.TAddress,
    asset: typebox_1.Type.Optional(nxtp_utils_1.TAddress),
    delegate: typebox_1.Type.Optional(nxtp_utils_1.TAddress),
    amount: typebox_1.Type.Optional(nxtp_utils_1.TIntegerString),
    slippage: typebox_1.Type.Optional(nxtp_utils_1.TIntegerString),
    callData: typebox_1.Type.Optional(typebox_1.Type.String()),
    relayerFee: typebox_1.Type.Optional(nxtp_utils_1.TIntegerString),
    relayerFeeInTransactingAsset: typebox_1.Type.Optional(typebox_1.Type.String()),
    receiveLocal: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    wrapNativeOnOrigin: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    unwrapNativeOnDestination: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
exports.SdkBumpTransferParamsSchema = typebox_1.Type.Object({
    domainId: nxtp_utils_1.TIntegerString,
    transferId: typebox_1.Type.String(),
    asset: typebox_1.Type.String(),
    relayerFee: nxtp_utils_1.TIntegerString,
});
exports.SdkUpdateSlippageSchema = typebox_1.Type.Object({
    domainId: nxtp_utils_1.TIntegerString,
    transferId: typebox_1.Type.String(),
    slippage: nxtp_utils_1.TIntegerString,
});
exports.SdkEstimateRelayerFeeParamsSchema = typebox_1.Type.Object({
    originDomain: nxtp_utils_1.TIntegerString,
    destinationDomain: nxtp_utils_1.TIntegerString,
    callDataGasAmount: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    priceIn: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Literal("native"), typebox_1.Type.Literal("usd")])),
    isHighPriority: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    originNativeTokenPrice: typebox_1.Type.Optional(typebox_1.Type.Number()),
    destinationNativeTokenPrice: typebox_1.Type.Optional(typebox_1.Type.Number()),
    destinationGasPrice: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.SdkUpdateSlippageParamsSchema = typebox_1.Type.Object({
    domainId: nxtp_utils_1.TIntegerString,
    transferId: typebox_1.Type.String(),
    slippage: nxtp_utils_1.TIntegerString,
});
exports.SdkCalculateAmountReceivedParamsSchema = typebox_1.Type.Object({
    originDomain: typebox_1.Type.String(),
    destinationDomain: typebox_1.Type.String(),
    originTokenAddress: typebox_1.Type.String(),
    amount: typebox_1.Type.String(),
    receiveLocal: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    checkFastLiquidity: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
//# sourceMappingURL=index.js.map